export const recipes = [
    {
        // BreakfastTacos: {
            display_name: "Breakfast Tacos",
            serving_size: "2 tacos",
            ingredients: [
                "2 large pasture raised eggs",
                "2 small corn torillas",
                "1/4 bell pepper (green)",
                "1/4 bell pepper (yellow, orange, or red)",
                "1/4 onion (sweet or white)",
                "1 slice of your favorite cheese (optional. I prefer pepperjack)",
                "1 tbsp chili powder",
                "1/2 tsp garlic powder",
                "1/2 tsp ground cumin (optional)",
                "1/4 tsp smoked paprika",
                "1/4 tsp black pepper",
                "salt (to taste)",
                "oil of choice",
            ],
            instructions: [
                "Heat pan on medium heat with ~1 tbsp of oil until hot (I use avocado or olive).",
                "While pan is heating, chop up bell peppers and onion (I save the remaining 3/4 for the next couple days :) )",
                "Add bell peppers, onion to pan, add seasonings, saute ~5 minutes.",
                "While bell peppers and onion are sizzling, place corn tortillas on separate pan on high heat. Monitor and flip these the rest of the way to ensure tortillas become nice n crispy.",
                "When the saute is looking right, crack your eggs into the pan.",
                "Scramble egg together with the veggies.",
                "Once egg is no longer runny, add cheese. (Tip: I usually break the cheese in half, divide the scramble in half, and place a slice of cheese on each half.)",
                "Cook for ~60 seconds longer to warm/melt cheese.",
                "Place half of your scramble on each toasted tortilla, and serve.",
            ],
            prep_time: "3 minutes",
            cook_time: "8 minutes",
            category: "breakfast"
        // }
    }
] 